import { giphyRed, giphyBlue, giphyGreen, giphyYellow, giphyPurple } from '@giphy/js-brand'
import { IAnimationShape } from '../types'
import { ANIMATION_BLOCK_SIZE, ANIMATION_SHAPES } from '../constants'

const getCutoutShape = () => ({
    type: 'cutout',
    color: giphyRed,
    width: ANIMATION_BLOCK_SIZE * 3,
    height: ANIMATION_BLOCK_SIZE * 3,
    path: [
        [0, 0],
        [ANIMATION_BLOCK_SIZE, 0],
        [ANIMATION_BLOCK_SIZE, ANIMATION_BLOCK_SIZE],
        [ANIMATION_BLOCK_SIZE * 2, ANIMATION_BLOCK_SIZE],
        [ANIMATION_BLOCK_SIZE * 2, ANIMATION_BLOCK_SIZE * 2],
        [ANIMATION_BLOCK_SIZE * 3, ANIMATION_BLOCK_SIZE * 2],
        [ANIMATION_BLOCK_SIZE * 3, ANIMATION_BLOCK_SIZE * 3],
        [0, ANIMATION_BLOCK_SIZE * 3],
        [0, 0],
    ],
})

const getLongBlockShape = () => ({
    type: 'long',
    color: Math.random() > 0.5 ? giphyBlue : giphyGreen,
    width: ANIMATION_BLOCK_SIZE * 7,
    height: ANIMATION_BLOCK_SIZE,
    path: [
        [0, 0],
        [ANIMATION_BLOCK_SIZE * 7, 0],
        [ANIMATION_BLOCK_SIZE * 7, ANIMATION_BLOCK_SIZE],
        [0, ANIMATION_BLOCK_SIZE],
        [0, 0],
    ],
})

const getBlockShape = () => ({
    type: 'short',
    color: Math.random() > 0.5 ? giphyYellow : giphyPurple,
    width: ANIMATION_BLOCK_SIZE * 5,
    height: ANIMATION_BLOCK_SIZE,
    path: [
        [0, 0],
        [ANIMATION_BLOCK_SIZE * 5, 0],
        [ANIMATION_BLOCK_SIZE * 5, ANIMATION_BLOCK_SIZE],
        [0, ANIMATION_BLOCK_SIZE],
        [0, 0],
    ],
})

export const getAnimationShape = () => {
    const type = ANIMATION_SHAPES[Math.floor(ANIMATION_SHAPES.length * Math.random())]
    switch (type) {
        case 'cutout':
            return getCutoutShape() as IAnimationShape
        case 'long':
            return getLongBlockShape() as IAnimationShape
        default:
            return getBlockShape() as IAnimationShape
    }
}
